// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const TestEquipmentLayout = ({ children, title }) => {

	return (
		<div className='TestEquipmentnLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

TestEquipmentLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

TestEquipmentLayout.defaultProps = {
	children: null,
	title: ''
}

export default TestEquipmentLayout;